import React from "react";
// Import the functions you need from the SDKs you need
import { getAuth, updateProfile } from "firebase/auth";
import { CreateUserRecord } from "./CreateUserRecord";
import { CreateBusinessRecord } from "./CreateBusinessRecord";
import sha256 from "./sha256";
import SeedBusinessRecord from "./SeedBusinessRecord";
import { createSubCollectionInClient } from "../dynamicFields/createSubCollectionInClient";
import { getCompleteCollection } from "../dynamicFields/getCompleteCollection";
import SeedUserRole from "./SeedUserRole";

export default async function PostRegister(
  userCredential,
  e,
  additionalUserInfo
) {
  const {
    name: Name,
    email: Email,
    password: Password,
    business: Business,
  } = e;

  const { uid, phoneNumber } = userCredential.user;

  if (additionalUserInfo.isNewUser) {
    /**
     * Update user name as by default its null
     */
    await updateProfile(getAuth().currentUser, { displayName: Name });
    /**
     * If this social auth provider is used first by the user
     * an instance of the user will be stored in the server
     */
    const record = {
      uid,
      name: Name,
      email: Email,
      business: Business,
      password: sha256(Password),
      phoneNumber: phoneNumber || "",
      bid: e.bid || "",
      aid: e.aid || "",
    };
    await CreateUserRecord(record, additionalUserInfo);
    if (Business != null) {
      // For agents, it'll not register any business
      await CreateBusinessRecord(record, additionalUserInfo);
    }
  }

  /**
   * Get business information and seed in localstorage
   */
  if (Business != null) await SeedBusinessRecord(uid);

  /**
   * Get user role and seed in localstorage
   */
  await SeedUserRole(uid);

  /**
   * Setting Predefined custom fields in clients collection
   */
  if (Business != null)
    await createSubCollectionInClient(await getCompleteCollection());

  return userCredential.user;
}
